document.addEventListener('DOMContentLoaded', function () {
    try {
        updateAnnouncementOffset();
        logoSlider();
        accordion();
        mediaSlider();
        productCardSlider();
        imageSlider();
        perfectProductAdd();
        bundleBuilderInit();
        paintFreeSliders();
        customPaintFreeSliders();
        thumbnailSlider();
        upsellBuy();
        allProductsGroupScroll();
        mobileMenuLink();
        reviewSlider();
        centerImageChange();
        stickyProduct();
        countrySelectRedirect();
        window.addEventListener('resize', updateAnnouncementOffset, { passive: true });
        document.addEventListener('shopify:section:load', countrySelectRedirect);
    } catch (error) {
        console.log(error)
    }
})

function perfectProductsSlider ( ) {

    let swiper = null;

    if(window.innerWidth < 750) { 
        swiper = new Swiper('.complementary-slide__inner', {
            slidesPerView : 1.2,
            spaceBetween : 10,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        })
    }
}

function logoSlider() {
    const logoSliders = document.querySelectorAll('.logo-slider__container');
 
    logoSliders.forEach(logoSlider => {
 
        const id = logoSlider.id;
 
        const quotes = logoSlider.querySelector('.logo-slider__quote--wrapper')
 
        const logoSpeed = (parseFloat(logoSlider.dataset.logoSpeed) || 5) * 1000;
        const textSpeed = (parseFloat(logoSlider.dataset.textSpeed) || 7) * 1000;
 
        const swiper = new Swiper(`#${id} .logo-slider__inner`, {
            slidesPerView : 'auto',
            spaceBetween : 0,
            loop : true,
            centeredSlides : true,
            loopAdditionalSlides : 30,    
            slideToClickedSlide: true,
            breakpoints: {
                990 : {
                    spaceBetween : 0,
                    loop : false,
                }
            },
            autoplay: {
                delay: logoSpeed,
                disableOnInteraction: false,
            },
        })
 
        const quoteItems = quotes.querySelectorAll('.logo-item__quote');
 
        if (quoteItems.length > 1) {
            setInterval(() => {
                const current = quotes.querySelector('.logo-item__quote.active');
                const next = quoteItems[(Array.from(quoteItems).indexOf(current) + 1) % quoteItems.length];
 
                current?.classList.remove('active');
                next.classList.add('active');
            }, textSpeed);
        }
 
        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
            swiper.params.autoplay.delay = logoSpeed;
            swiper.update()
        }
 
        swiper.on('reachEnd', () => {
            setTimeout(() => {
              swiper.slideTo(0);
            }, 2500);
        });
    })
}

function accordion() {
    document.querySelectorAll('.faqs-group__inner').forEach(group => {
        group.querySelectorAll('.faqs-group__item').forEach(accordion => {
            accordion.querySelector('.accordion-heading').addEventListener('click', function () {
                let body = accordion.querySelector('.accordion-body');

                accordion.classList.toggle('active');

                if (accordion.classList.contains('active')) {
                    body.style.maxHeight = body.scrollHeight + 'px';
                } else {
                    body.style.maxHeight = 0;
                }

            })
        })
    })
}

function mediaSlider () {
    let sliderComponents = document.querySelectorAll('.media-slider__container');
    if (!sliderComponents) return;
    
    sliderComponents.forEach(comp => {

        let sliderId = comp.id;

        const swiper = new Swiper(`#${sliderId} .media-slider__inner`, {
            slidesPerView: 1.5,
            spaceBetween: 10,
            loop : false,  
            slideToClickedSlide: true,
            centeredSlides : true,
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                990 : {
                    slidesPerView: 3,
                    spaceBetween : 10,
                    pagination: false
                }
            }
        })

        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
            // const video = swiper.slides[Math.ceil(swiper.slides.length / 2 - 1)];

            swiper.slides.forEach(ele => {
                console.log(ele)
                //ele.querySelector('video').play()
            })
        }

    })
}

function imageSlider () {
    let sliderComponents = document.querySelectorAll('.image-slider__container');

    
    sliderComponents.forEach(comp => {

        let sliderId = comp.id;

        const swiper = new Swiper(`#${sliderId} .image-slider__inner`, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop : false,  
            slideToClickedSlide: true,
            centeredSlides : true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                990 : {
                    slidesPerView: 3,
                    spaceBetween : 10,
                    pagination: false
                }
            }
        })

        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
        }
    })
}

function productCardSlider () {
    let cards = document.querySelectorAll('.collection-product__card');

    cards.forEach(card => {
        let id = card.id;

        if(id) {
            new Swiper(`#${id} .product-card__media-slider`, {
                slidesPerView : 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            })
        }
    })
}

function paintFreeSliders() {
   let slides = document.querySelectorAll('.paint-free__container');

    slides.forEach(slide => {
        const id = slide.id;

        const medias = document.querySelector('.paint-free__media')
        const descriptions = document.querySelector('.paint-free__description-count')
        
        const swiper = new Swiper(`#${id} .paint-free__description`, {
            slidesPerView : 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        swiper.on('slideChange', function () {
            const currentIndex = swiper.activeIndex;

            descriptions.querySelector('.active')?.classList.remove('active');
            descriptions.querySelector(`[data-desc-index="${currentIndex + 1}"]`)?.classList.add('active');

            medias.querySelector('.active')?.classList.remove('active');
            medias.querySelector(`[data-point-index="${currentIndex + 1}"]`)?.classList.add('active');
        });

        medias.querySelectorAll('.media-point__position')?.forEach(media => {
            media.addEventListener('click' , function (e) {
                swiper.slideTo(media.getAttribute('data-point-index') - 1)
            })
        })

        descriptions.querySelectorAll('.description-count__number')?.forEach(media => {
            media.addEventListener('click' , function (e) {
                swiper.slideTo(media.getAttribute('data-desc-index') - 1)
            })
        })
    });
}

function perfectProductAdd() {
    const buy_buttons = document.querySelectorAll('.perfect-product-buy_button');
    buy_buttons.forEach(buy_button => {
        buy_button.addEventListener('click', function (e) {
            
            const product_id = buy_button.closest('.item__info').querySelector('#variant_id').value;
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            const data = {
                'id' : product_id,
                'quantity' : 1,
                "sections" : cart.getSectionsToRender().map((section) => section.id),
                "sections_url" : window.location.pathname
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then (res => {
                return res.json()
            }).then (resJson => {
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                setTimeout(() => {
                    cart.renderContents(resJson);
                }, 100);
            })
        })
    })

    document.querySelectorAll('.item__info-variants select').forEach(select => {

        const item = select.closest('.perfect-product__item');

        const json = JSON.parse(item.querySelector('[data-upsell-json]').textContent);

        const price = item.querySelector('.item__info-price');
        const discount = parseFloat(price.dataset.discountPercent);

        select.addEventListener('change', function () {
            const id = select.value;

            const variant = json.variants.find(v => v.id == id);

            if (discount) {
                price.innerHTML = `<div class="price">${getMoney((variant.price / 100) * discount)}</div><div class="compare">${getMoney(variant.price / 100)}</div>`
            } else {
                price.innerHTML = `<div class="price">${getMoney(variant.price / 100)}</div>`
            }
        })
    })
}

function getMoney(amount) {
    return new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active,
    }).format(amount);
}

function thumbnailSlider() {
    const thumbnailWrapper = document.querySelector('.thumbnail-slider');

    if (thumbnailWrapper) {
        let swiper = new Swiper('.thumbnail-slider', {
            slidesPerView : 4.5,
            spaceBetween : 10,
            breakpoints: {
                990 : {
                    slidesPerView: 5.5,
                }
            }
        })
    }
}

function upsellBuy() { 
    const upsellProducts = document.querySelectorAll('.upsell-product--item');

    if (!customElements.get('upsell-cart-item')) {
        customElements.define('upsell-cart-item', 
            class upsellCartItem extends HTMLElement {
                constructor (){
                    super()

                    const buyButton = this.querySelector('.product--buy');
            
                    buyButton.addEventListener('click', function (e) {
                        const cart = document.querySelector('cart-drawer');
                        const data = {
                            'id' : buyButton.dataset.productId,
                            'quantity' : 1,
                            "sections" : cart.getSectionsToRender().map((section) => section.id),
                            "sections_url" : window.location.pathname
                        };
            
                        fetch('/cart/add.js', {
                            method : "POST",
                            headers : {
                                'Content-Type': 'application/json'
                            },
                            body : JSON.stringify(data)
                        }).then(res => {
                            return res.json();
                        }).then(resJson => {
                            cart.getSectionsToRender().forEach((section) => {
                            const sectionElement = section.selector
                                ? document.querySelector(section.selector)
                                : document.getElementById(section.id);
                        
                            if (!sectionElement) return;
                                sectionElement.innerHTML = cart.getSectionInnerHTML(resJson.sections[section.id], section.selector);
                            });

                            cart.querySelector('#CartDrawer-Overlay').addEventListener('click', cart.close.bind(cart));

                        })
                    })
                }
            }
        )
    }
}

function allProductsGroupScroll () {
    const labels = document.querySelectorAll('.products_label--item');

    labels.forEach(label => {
        label.addEventListener('click', function (e) {
            let wrapper = document.querySelector(`[data-block-group-id="${label.id}"]`);
            smoothScroll( wrapper.offsetTop , 500);
        })
    })
}

function smoothScroll(target, duration) {
    const start = window.scrollY;
    const distance = target - start;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Make sure progress does not exceed 1
        const ease = easeInOutQuad(progress); // You could use any easing function here
        window.scrollTo(0, start + (distance * ease));

        if (timeElapsed < duration) {
            requestAnimationFrame(animation); // Keep animating
        }
    }

    requestAnimationFrame(animation);
}

function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function mobileMenuLink() {
    const menuItems = document.querySelectorAll('.menu-drawer-accordion-menu--item');

    const toggleItem = (item) => {
        const toggle = item.querySelector('.accordion-menu__toggle');
        const hasSubmenu = !!item.querySelector('.accordion-menu__body');

        if (!hasSubmenu) return false;

        item.parentElement?.querySelectorAll('.menu-drawer-accordion-menu--item.open')?.forEach(sib => {
            if (sib !== item) sib.classList.remove('open');
        });

        if (item.classList.contains('open')) {
            item.classList.remove('open');
        } else {
            item.classList.add('open');
        }
        return true;
    };

    menuItems.forEach(item => {
        const toggle = item.querySelector('.accordion-menu__toggle');
        if (!toggle) return;

        toggle.addEventListener('click', function(e) {
            const handled = toggleItem(item);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        item.addEventListener('click', function(e) {
            if (e.target.closest('a')) return;
            const handled = toggleItem(item);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    });
}

function reviewSlider() {
    const reviewSliders = document.querySelectorAll('.reviews-slider__inner');

    reviewSliders.forEach(slider => {
        const sliderId = slider.id;

        var thumbs = new Swiper(`#${sliderId} .reviews-thumbnail__slider`, {
            slidesPerView: 4,
            spaceBetween: 10,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        
        var slider = new Swiper(`#${sliderId} .reviews-main__slider`, {
            slidesPerView: 1,
            spaceBetween : 30,
            centeredSlides: true,
            loop: true,
            loopedSlides: 6,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: thumbs
            },
            breakpoints: {
                990 : {
                    slidesPerView: 1.5,
                    spaceBetween : 15
                },
                1200 : {
                    slidesPerView: 2,
                    spaceBetween : 15
                }
            }
        });
    })
}

function centerImageChange () {
    const centerImages = document.querySelectorAll('.center-image__container');

    centerImages.forEach(centerImage => {
        
        const mainImage = centerImage.querySelector('.center-image__media')
        
        centerImage.querySelectorAll('.center-image__card').forEach(card => {
            card.addEventListener('click', function(e) {
                const cardId = this.dataset.cardId;
                centerImage.querySelector('.center-image__card.active')?.classList.remove('active');

                card.classList.add('active');

                mainImage.querySelector(`.main-image.active`)?.classList.remove('active');
                mainImage.querySelector(`[data-card-id="${cardId}"]`)?.classList.add('active');
            })
        })

    })
}

function stickyProduct() {
    const stickyProducts = document.querySelectorAll('.sticky-product__container');
    const mainProduct = document.querySelector('.product');

    stickyProducts.forEach(stickyProduct => {

        if (stickyProduct) {
            stickyProduct.querySelector('.sticky-atc').addEventListener('click', function (e) {
                mainProduct.querySelector('.product-form__submit').click();
            })
        }

        const updateVisibility = () => {
            if (!stickyProduct || !mainProduct) return;
            const atcButton = mainProduct.querySelector('.product-form__submit');
            if (!atcButton) return;

            const rect = atcButton.getBoundingClientRect();
            // Show only after we've scrolled past the main ATC (its top is above viewport)
            const scrolledPastMainATC = rect.top <= 0;

            if (scrolledPastMainATC) {
                stickyProduct.classList.remove('hide');
            } else {
                stickyProduct.classList.add('hide');
            }
        };

        ['scroll','resize','orientationchange'].forEach(evt => window.addEventListener(evt, updateVisibility, { passive: true }));
        // initial check
        updateVisibility();
    })
}

function updateAnnouncementOffset() {
    const bar = document.querySelector('.announcement-bar-section');
    const height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
}

function countrySelectRedirect() {
    const selects = document.querySelectorAll('.supporting-menu__country .country-select');

    selects.forEach(select => {
        // Remove prior listener by cloning (prevents stacking on editor reloads)
        const newSelect = select.cloneNode(true);
        if (select.parentNode) select.parentNode.replaceChild(newSelect, select);

        newSelect.addEventListener('change', function () {
            const url = (this.value || '').trim();
            if (url) {
                window.location.assign(url);
            }
        })
    })
}

window.addEventListener('DOMContentLoaded', function () {
    
    const centerImages = document.querySelectorAll('.center-image__container');

    centerImages.forEach(centerImage => {
        let cards = centerImage.querySelectorAll('.center-image__card');
        let currentIndex = 0;
        const totalHighlights = cards.length;
        let autoCycle;

        function showHighlight(index) {
            cards.forEach((highlight, i) => {
                if (index == i) {
                    highlight.click()
                }
            });
        }

        function nextHighlight() {
            currentIndex = (currentIndex + 1) % totalHighlights;
            showHighlight(currentIndex);
        }

        function startAutoCycle() {
            autoCycle = setInterval(() => {
                if (currentIndex < totalHighlights - 1) {
                    nextHighlight();
                } else {
                    showHighlight(0)
                    clearInterval(autoCycle);
                }
            }, 5000);
        }

        startAutoCycle()
    })

})

function customPaintFreeSliders() {
    let slides = document.querySelectorAll('.custom-paint-free__container');
 
     slides.forEach(slide => {
         const id = slide.id;

         const medias = slide.querySelector('.custom-paint-free__media')
         const descriptions = slide.querySelector('.custom-paint-free__description-count')
         
         const swiper = new Swiper(`#${id} .custom-paint-free__description`, {
             slidesPerView : 1,
             pagination: {
                 el: ".swiper-pagination",
                 clickable: true,
             },
         });

         swiper.on('slideChange', function () {
             const currentIndex = swiper.activeIndex;

             descriptions.querySelector('.active')?.classList.remove('active');
             descriptions.querySelector(`[data-desc-index="${currentIndex + 1}"]`)?.classList.add('active');

             medias.querySelector('.active')?.classList.remove('active');
             medias.querySelector(`[data-point-index="${currentIndex + 1}"]`)?.classList.add('active');
             
             // Switch media slides
             medias.querySelectorAll('.custom-paint-free__media-slide').forEach(slide => {
                 slide.classList.remove('active');
             });
             medias.querySelector(`[data-media-index="${currentIndex + 1}"]`)?.classList.add('active');
         });

         medias.querySelectorAll('.media-point__position')?.forEach(media => {
             media.addEventListener('click' , function (e) {
                 swiper.slideTo(media.getAttribute('data-point-index') - 1)
             })
         })

         descriptions.querySelectorAll('.description-count__number')?.forEach(media => {
             media.addEventListener('click' , function (e) {
                 swiper.slideTo(media.getAttribute('data-desc-index') - 1)
             })
         })
     });
}

/* Hide compare at price if it's equal to the product price */
document.addEventListener("DOMContentLoaded", () => {
  const normalizePrice = (text) => {
    const cleaned = (text || "")
      .replace(/\s+/g, " ")
      .replace(/[^\d.,]/g, "")
      .trim();

    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");

    let normalized = cleaned;
    if (lastComma > lastDot) normalized = cleaned.replace(/\./g, "").replace(",", ".");
    else normalized = cleaned.replace(/,/g, "");

    const n = Number(normalized);
    return Number.isFinite(n) ? n : NaN;
  };

  const observed = new WeakSet();
  const rafQueued = new WeakSet();

  const hide = (el) => {
    if (!el) return;
    el.style.setProperty("display", "none", "important");
  };

  const unhide = (el) => {
    if (!el) return;
    el.style.removeProperty("display");
    if (el.getAttribute("style") === "") el.removeAttribute("style");
  };

  const schedule = (root, fn) => {
    if (!root || rafQueued.has(root)) return;
    rafQueued.add(root);
    requestAnimationFrame(() => {
      rafQueued.delete(root);
      fn();
    });
  };

  function fixPriceContainer(root) {
    root.querySelectorAll(".price__container").forEach((container) => {
      const saleWrap = container.querySelector(".price__sale");
      if (!saleWrap) return;

      const saleEl = saleWrap.querySelector(".price-item--sale");
      if (!saleEl) return;

      const sale = normalizePrice(saleEl.textContent);
      if (!Number.isFinite(sale)) return;

      saleWrap.querySelectorAll(".price-item--regular").forEach((regularEl) => {
        const regular = normalizePrice(regularEl.textContent);
        if (!Number.isFinite(regular)) return;

        if (sale === regular) hide(regularEl);
        else unhide(regularEl);
      });
    });
  }

  function fixPack(root) {
    root.querySelectorAll(".pack--price").forEach((container) => {
      const minEl = container.querySelector(".pack--min-price");
      const maxEl = container.querySelector(".pack--max-price");
      if (!minEl || !maxEl) return;

      const min = normalizePrice(minEl.textContent);
      const max = normalizePrice(maxEl.textContent);

      if (Number.isFinite(min) && Number.isFinite(max) && min === max) hide(maxEl);
      else unhide(maxEl);
    });
  }

  function fixProductPrice(root) {
    root.querySelectorAll(".product__price").forEach((container) => {
      const saleEl = container.querySelector(".price-item--sale");
      const regularEl = container.querySelector(".price-item--regular");
      const badgeEl = container.querySelector(".price__badge-sale");
      if (!saleEl || !regularEl) return;

      const sale = normalizePrice(saleEl.textContent);
      const regular = normalizePrice(regularEl.textContent);

      if (Number.isFinite(sale) && Number.isFinite(regular) && sale === regular) {
        hide(regularEl);
        hide(badgeEl);
      } else {
        unhide(regularEl);
        unhide(badgeEl);
      }
    });
  }

  function fixItemCompare(root) {
    root.querySelectorAll(".perfect-product__item .item__info-price").forEach((box) => {
      const priceEl = box.querySelector(".price");
      const compareEl = box.querySelector(".compare");
      if (!priceEl || !compareEl) return;

      const price = normalizePrice(priceEl.textContent);
      const compare = normalizePrice(compareEl.textContent);

      if (Number.isFinite(price) && Number.isFinite(compare) && price === compare) {
        compareEl.remove();
      }
    });
  }

  function fixCardBadges(root) {
    root.querySelectorAll(".card__badge .badge").forEach((badge) => {
      const value = parseFloat(badge.textContent.replace(/[^\d.]/g, ""));
      if (Number.isFinite(value) && value === 0) {
        badge.style.setProperty("display", "none", "important");
      } else {
        badge.style.removeProperty("display");
        if (badge.getAttribute("style") === "") badge.removeAttribute("style");
      }
    });
  }

  function fixStickyAtc(root) {
    root.querySelectorAll(".sticky-atc, .sticky-product__price").forEach((wrap) => {
        const priceEl = wrap.querySelector(".price:not(.compare_price)");
        const compareEl = wrap.querySelector(".compare_price");
        if (!priceEl || !compareEl) return;

        const price = normalizePrice(priceEl.textContent);
        const compare = normalizePrice(compareEl.textContent);

        if (Number.isFinite(price) && Number.isFinite(compare) && price === compare) {
        hide(compareEl);
        } else {
        unhide(compareEl);
        }
    });
    }

  function fixUpsellCartPrices(root) {
    root.querySelectorAll(".upsell-product--item__price").forEach((container) => {
      const priceEl = container.querySelector(".item--price");
      const compareEl = container.querySelector(".item--compare-price");
      if (!priceEl || !compareEl) return;

      const price = normalizePrice(priceEl.textContent);
      const compare = normalizePrice(compareEl.textContent);

      if (Number.isFinite(price) && Number.isFinite(compare) && price === compare) hide(compareEl);
      else unhide(compareEl);
    });
  }

  function runAll(root) {
    fixItemCompare(root);
    fixPack(root);
    fixPriceContainer(root);
    fixProductPrice(root);
    fixCardBadges(root);
    fixStickyAtc(root);
    fixUpsellCartPrices(root);
  }

  function observe(el, runner) {
    if (!el || observed.has(el)) return;
    observed.add(el);

    const mo = new MutationObserver(() => {
      schedule(el, () => runner(el));
    });

    mo.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    runner(el);
  }

  function observeTargets() {
    document.querySelectorAll(".swiper, .swiper-container, .swiper-wrapper").forEach((sw) => observe(sw, runAll));
    document.querySelectorAll("product-recommendations").forEach((pr) => observe(pr, runAll));
    document.querySelectorAll(".product-form__packs--wrapper").forEach((wrap) => observe(wrap, runAll));
    document.querySelectorAll(".product__price").forEach((pp) => observe(pp, runAll));
    document.querySelectorAll(".sticky-atc").forEach((btn) => observe(btn, runAll));

    document.querySelectorAll("upsell-cart-item, .cart-drawer, cart-drawer, #CartDrawer").forEach((cd) => {
      observe(cd, runAll);
    });
  }

  const rerunProductArea = () => {
    const roots = new Set();

    document.querySelectorAll(".product-form__packs--wrapper").forEach((el) => roots.add(el));
    document.querySelectorAll(".product__price").forEach((el) => roots.add(el));
    document.querySelectorAll("product-info, product-form").forEach((el) => roots.add(el));

    if (roots.size === 0) roots.add(document);

    roots.forEach((root) => {
      schedule(root, () => runAll(root));
      requestAnimationFrame(() => schedule(root, () => runAll(root)));
    });
  };

  observeTargets();
  runAll(document);

  document.addEventListener("change", (e) => {
    if (
      e.target.closest(".product-form__packs--wrapper") ||
      e.target.closest("fieldset.product-form__input") ||
      e.target.closest("variant-selects") ||
      e.target.closest("product-form") ||
      e.target.closest("product-info")
    ) {
      rerunProductArea();
    }
    fixUpsellCartPrices(document);
  });

  document.addEventListener("variant:change", () => {
    rerunProductArea();
    fixUpsellCartPrices(document);
  });

  let tries = 0;
  const timer = setInterval(() => {
    observeTargets();
    tries += 1;
    if (++tries >= 5) clearInterval(timer);
  }, 250);
});

/* Kaching bundles price and quantity sync (except bundles) */
(() => {
  const hasBundleV1orV2 = document.querySelector(
    '.product__info-container.product-bundle-v1, .product__info-container.product-bundle-v2'
  );

  if (hasBundleV1orV2) return;

  const LABEL_WRAPPER = '.product-form__pack-label, .product-from__pack-label';
  const SINGLE_NAME = '.single-pack-name';
  const DOUBLE_NAME = '.double-pack-name';

  const PRICE_BOX = '.product__info-wrapper .product__price';
  const SALE = '.price-item--sale';
  const REGULAR = '.price-item--regular';
  const BADGE = '.price__badge-sale';

  const BAR = '.kaching-bundles__bar';
  const BAR_SELECTED = '.kaching-bundles__bar.kaching-bundles__bar--selected';
  const BAR_TITLE = '.kaching-bundles__bar-title';
  const BAR_PRICE = '.kaching-bundles__bar-price';
  const BAR_FULL = '.kaching-bundles__bar-full-price';

  const PRODUCT_FORM = 'product-form form, form[action*="/cart/add"]';
  const QUANTITY_INPUT = 'input[name="quantity"]';

  const norm = (t) => (t || '').replace(/\s+/g, ' ').trim();

  const hideEl = (el) => {
    if (!el) return;
    el.style.display = 'none';
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
  };

  const showEl = (el, display = '') => {
    if (!el) return;
    el.style.display = display;
    el.hidden = false;
    el.removeAttribute('aria-hidden');
  };

  const setText = (el, text) => {
    if (!el || !text) return;
    if (norm(el.textContent) === text) return;
    el.textContent = text;
  };

  const parseMoney = (text) => {
    const t = norm(text);
    if (!t) return null;

    const numMatch = t.match(/-?[\d.,]+/);
    if (!numMatch) return null;

    let numStr = numMatch[0];
    const lastDot = numStr.lastIndexOf('.');
    const lastComma = numStr.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    if (decPos >= 0) {
      const intPart = numStr.slice(0, decPos).replace(/[^\d-]/g, '');
      const decPart = numStr.slice(decPos + 1).replace(/[^\d]/g, '');
      numStr = `${intPart}.${decPart}`;
    } else {
      numStr = numStr.replace(/[^\d-]/g, '');
    }

    const value = Number(numStr);
    return Number.isFinite(value) ? value : null;
  };

  const getBars = () => Array.from(document.querySelectorAll(BAR));

  const getSelectedBar = () => {
    return (
      document.querySelector(BAR_SELECTED) ||
      document.querySelector(`${BAR} input[type="radio"]:checked`)?.closest(BAR) ||
      document.querySelector(BAR) ||
      null
    );
  };

  const getBarTitle = (bar) => norm(bar?.querySelector(BAR_TITLE)?.textContent);

  const getBarQuantity = (bar) => {
    if (!bar) return null;

    const title = getBarTitle(bar);
    const titleMatch = title.match(/^(\d+)\s*x\b/i) || title.match(/(\d+)/);
    if (titleMatch) {
      const qty = Number(titleMatch[1]);
      if (Number.isFinite(qty) && qty > 0) return qty;
    }

    const labelText = norm(bar.textContent);
    const fallbackMatch = labelText.match(/^(\d+)\s*x\b/i) || labelText.match(/(\d+)/);
    if (fallbackMatch) {
      const qty = Number(fallbackMatch[1]);
      if (Number.isFinite(qty) && qty > 0) return qty;
    }

    return null;
  };

  const updatePackLabels = (bar) => {
    const wrapper = document.querySelector(LABEL_WRAPPER);
    if (!wrapper) return;

    const singleEl = wrapper.querySelector(SINGLE_NAME);
    const doubleEl = wrapper.querySelector(DOUBLE_NAME);

    const bars = getBars();
    const firstTitle = getBarTitle(bars[0]);
    const secondTitle = getBarTitle(bars[1]);
    const selectedTitle = getBarTitle(bar);

    if (singleEl) {
      setText(singleEl, selectedTitle || firstTitle);
    }

    if (doubleEl) {
      setText(doubleEl, selectedTitle || secondTitle);
    }
  };

  const updatePriceFromBar = (bar) => {
    const priceBox = document.querySelector(PRICE_BOX);
    if (!priceBox || !bar) return;

    const saleEl = priceBox.querySelector(SALE);
    const regEl = priceBox.querySelector(REGULAR);
    const badgeEl = priceBox.querySelector(BADGE);

    const barSale = norm(bar.querySelector(BAR_PRICE)?.textContent);
    const barFull = norm(bar.querySelector(BAR_FULL)?.textContent);

    if (saleEl && barSale) {
      setText(saleEl, barSale);
      showEl(saleEl);
    }

    if (!barFull) {
      if (regEl) {
        regEl.textContent = '';
        hideEl(regEl);
      }
      if (badgeEl) {
        badgeEl.textContent = '';
        hideEl(badgeEl);
      }
      return;
    }

    if (regEl) {
      setText(regEl, barFull);
      showEl(regEl);
    }

    if (badgeEl) {
      const sale = parseMoney(barSale);
      const full = parseMoney(barFull);

      if (sale && full && full > sale) {
        const off = Math.round((1 - sale / full) * 100);
        setText(badgeEl, `${off}% OFF`);
        showEl(badgeEl);
      } else {
        badgeEl.textContent = '';
        hideEl(badgeEl);
      }
    }
  };

  const updateQuantityFromBar = (bar) => {
    const form =
      document.querySelector(PRODUCT_FORM) ||
      document.querySelector(QUANTITY_INPUT)?.closest('form');

    if (!form || !bar) return;

    const qtyInput = form.querySelector(QUANTITY_INPUT);
    if (!qtyInput) return;

    const qty = getBarQuantity(bar);
    if (!qty) return;

    if (String(qtyInput.value) !== String(qty)) {
      qtyInput.value = String(qty);
      qtyInput.setAttribute('value', String(qty));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const updateFromBar = (bar) => {
    if (!bar) return;
    updatePackLabels(bar);
    updatePriceFromBar(bar);
    updateQuantityFromBar(bar);
  };

  const bindEvents = () => {
    document.addEventListener(
      'change',
      (e) => {
        const input = e.target.closest(`${BAR} input[type="radio"]`);
        if (!input) return;

        const bar = input.closest(BAR);
        updateFromBar(bar);
      },
      true
    );

    document.addEventListener(
      'click',
      (e) => {
        const bar = e.target.closest(BAR);
        if (!bar) return;

        updateFromBar(bar);
      },
      true
    );

    document.addEventListener(
      'pointerdown',
      (e) => {
        const bar = e.target.closest(BAR);
        if (!bar) return;

        updateFromBar(bar);
      },
      true
    );
  };

  const init = () => {
    let tries = 0;
    const maxTries = 10;

    const tick = () => {
      const bars = getBars();
      const selectedBar = getSelectedBar();
      const priceBox = document.querySelector(PRICE_BOX);
      const form =
        document.querySelector(PRODUCT_FORM) ||
        document.querySelector(QUANTITY_INPUT)?.closest('form');

      if (bars.length && selectedBar && priceBox && form) {
        updateFromBar(selectedBar);
        bindEvents();
        return;
      }

      tries += 1;
      if (tries < maxTries) {
        requestAnimationFrame(tick);
      }
    };

    tick();
  };

  init();
})();

/* Kaching bundles rework for product bundles v1 and v2 */
(() => {
  const ROOT_SELECTOR = '.product-information .shopify-app-block, .shopify-section, body';

  const BAR_SELECTOR = '.kaching-bundles__bar';
  const PRICING_SELECTOR = '.kaching-bundles__bar-pricing';
  const PRICE_SELECTOR = '.kaching-bundles__bar-price';
  const COMPARE_SELECTOR = '.kaching-bundles__bar-full-price';
  const LABEL_SELECTOR = '.kaching-bundles__bar-label';
  const CONTENT_SELECTOR = '.kaching-bundles__bar-content';

  const OFF_BADGE_CLASS = 'bundle-off-badge';
  const SAVE_BADGE_CLASS = 'bundle-save-badge';
  const PER_PILLOW_CLASS = 'bundle-per-pillow';
  const COMPARE_WRAP_CLASS = 'compare-price';

  const parseMoney = (text) => {
    const t = (text || '').replace(/\s+/g, ' ').trim();
    if (!t) return null;

    const currencyMatch = t.match(/[$€£¥]|[A-Z]{3}/);
    const currencyToken = currencyMatch ? currencyMatch[0] : '';

    const numMatch = t.match(/-?[\d.,]+/);
    if (!numMatch) return null;

    let numStr = numMatch[0];
    const lastDot = numStr.lastIndexOf('.');
    const lastComma = numStr.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    if (decPos >= 0) {
      const intPart = numStr.slice(0, decPos).replace(/[^\d-]/g, '');
      const decPart = numStr.slice(decPos + 1).replace(/[^\d]/g, '');
      numStr = `${intPart}.${decPart}`;
    } else {
      numStr = numStr.replace(/[^\d-]/g, '');
    }

    const value = Number(numStr);
    if (!Number.isFinite(value)) return null;

    return { value, currencyToken };
  };

  const formatMoney = (value, currencyToken) => {
    if (!Number.isFinite(value)) return '';
    const token = (currencyToken || '').trim();
    const num = value.toFixed(2);
    return token ? `${token}${num}` : num;
  };

  const wrapCompareText = (compareEl) => {
    if (!compareEl) return;
    if (compareEl.querySelector(`.${COMPARE_WRAP_CLASS}`)) return;

    const textNodes = [...compareEl.childNodes].filter(
      (n) => n.nodeType === Node.TEXT_NODE && (n.textContent || '').trim()
    );
    if (!textNodes.length) return;

    const span = document.createElement('span');
    span.className = COMPARE_WRAP_CLASS;
    span.textContent = (textNodes[0].textContent || '').trim();

    compareEl.replaceChild(span, textNodes[0]);
  };

  const ensureOffBadge = (compareEl, offPct) => {
    let wrap = compareEl.querySelector('[data-bundle-off="1"]');
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.setAttribute('data-bundle-off', '1');
      wrap.className = OFF_BADGE_CLASS;
      wrap.style.marginLeft = '8px';
      wrap.style.whiteSpace = 'nowrap';

      const value = document.createElement('span');
      wrap.appendChild(value);

      wrap.appendChild(document.createTextNode(' OFF'));
      compareEl.appendChild(wrap);
    }

    const valueEl = wrap.querySelector('span');
    const sig = String(offPct);
    if (valueEl.dataset.sig !== sig) {
      valueEl.textContent = `${offPct}%`;
      valueEl.dataset.sig = sig;
    }
  };

  const ensurePerPillow = (content, text) => {
    let div = content.querySelector('[data-bundle-per-pillow="1"]');
    if (!div) {
      div = document.createElement('div');
      div.setAttribute('data-bundle-per-pillow', '1');
      div.className = PER_PILLOW_CLASS;
      content.appendChild(div);
    }

    if (div.dataset.sig !== text) {
      div.textContent = text;
      div.dataset.sig = text;
    }

    return div;
  };

  const ensureRadioInMainIfBundleV1 = (bar) => {
    const hasBundleV1 = !!document.querySelector('.product__info-container.product-bundle-v1');
    if (!hasBundleV1) return;

    const main = bar.querySelector('.kaching-bundles__bar-main');
    if (!main) return;

    if (main.querySelector(':scope > .kaching-bundles__bar-radio')) return;

    const radio = document.createElement('div');
    radio.className = 'kaching-bundles__bar-radio';

    main.insertBefore(radio, main.firstChild);
  };

  const ensureFirstLineOffBadgeIfBundleV1 = (bar) => {
    if (!document.querySelector('.product__info-container.product-bundle-v1')) return;

    const firstLine = bar.querySelector('.kaching-bundles__bar-first-line');
    const priceEl = bar.querySelector('.kaching-bundles__bar-price');
    const compareEl = bar.querySelector('.kaching-bundles__bar-full-price');

    if (!firstLine || !priceEl || !compareEl) return;

    const price = parseMoney(priceEl.textContent);
    const compare = parseMoney(compareEl.textContent);

    if (!price || !compare || compare.value <= price.value) {
      const existing = firstLine.querySelector('[data-bundle-off="1"]');
      if (existing) existing.remove();
      return;
    }

    const offPct = Math.round((1 - price.value / compare.value) * 100);

    let badge = firstLine.querySelector('[data-bundle-off="1"]');
    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('data-bundle-off', '1');
      badge.className = 'bundle-off-badge';

      const value = document.createElement('span');
      badge.appendChild(value);
      badge.appendChild(document.createTextNode(' OFF'));

      firstLine.appendChild(badge);
    }

    const valueEl = badge.querySelector('span');
    const sig = String(offPct);
    if (valueEl.dataset.sig !== sig) {
      valueEl.textContent = `${offPct}%`;
      valueEl.dataset.sig = sig;
    }
  };

  const ensureSaveDiv = (content, beforeNode, saveText) => {
    let div = content.querySelector('[data-bundle-save="1"]');
    if (!div) {
      div = document.createElement('div');
      div.setAttribute('data-bundle-save', '1');
      div.className = SAVE_BADGE_CLASS;
      div.style.whiteSpace = 'nowrap';

      const prefix = document.createElement('span');
      prefix.textContent = 'SAVE ';
      div.appendChild(prefix);

      const value = document.createElement('span');
      div.appendChild(value);

      if (beforeNode && content.contains(beforeNode)) {
        content.insertBefore(div, beforeNode);
      } else {
        content.appendChild(div);
      }
    } else {
      if (beforeNode && content.contains(beforeNode) && div.nextSibling !== beforeNode) {
        content.insertBefore(div, beforeNode);
      }
    }

    const valueEl = div.querySelector('span:last-child');
    if (valueEl.dataset.sig !== saveText) {
      valueEl.textContent = saveText;
      valueEl.dataset.sig = saveText;
    }
  };

  const removeSaveFromPricing = (pricing) => {
    const save = pricing.querySelector('[data-bundle-save="1"]');
    if (save) save.remove();
  };

  const updateBar = (bar) => {
    ensureRadioInMainIfBundleV1(bar);
    const pricing = bar.querySelector(PRICING_SELECTOR);
    const priceEl = bar.querySelector(PRICE_SELECTOR);
    const compareEl = bar.querySelector(COMPARE_SELECTOR);
    ensureFirstLineOffBadgeIfBundleV1(bar);
    const labelEl = bar.querySelector(LABEL_SELECTOR);
    const contentEl = bar.querySelector(CONTENT_SELECTOR);

    if (!pricing || !priceEl || !labelEl || !contentEl) return;

    wrapCompareText(compareEl);

    const price = parseMoney(priceEl.textContent);
    const compareTextEl = compareEl?.querySelector(`.${COMPARE_WRAP_CLASS}`);
    const compare = compareTextEl ? parseMoney(compareTextEl.textContent) : (compareEl ? parseMoney(compareEl.textContent) : null);

    if (compareEl && price && compare && compare.value > price.value) {
      const offPct = Math.round((1 - price.value / compare.value) * 100);
      ensureOffBadge(compareEl, offPct);
    } else {
      const offWrap = compareEl?.querySelector('[data-bundle-off="1"]');
      if (offWrap) offWrap.remove();
    }

    let perPillowDiv = null;
    const qty = Number(((labelEl.textContent || '').match(/\d+/) || [])[0]);
    if (price && Number.isFinite(qty) && qty > 0) {
      const per = price.value / qty;
      const token = price.currencyToken || compare?.currencyToken || '';
      perPillowDiv = ensurePerPillow(contentEl, `${formatMoney(per, token)} per pillow`);
    } else {
      const perDiv = contentEl.querySelector('[data-bundle-per-pillow="1"]');
      if (perDiv) perDiv.remove();
    }

    removeSaveFromPricing(pricing);

    if (price && compare && compare.value > price.value) {
      const save = compare.value - price.value;
      const token = compare.currencyToken || price.currencyToken;
      ensureSaveDiv(contentEl, perPillowDiv, formatMoney(save, token));
    } else {
      const saveDiv = contentEl.querySelector('[data-bundle-save="1"]');
      if (saveDiv) saveDiv.remove();
    }
  };

  const enforce = (root) => {
    root.querySelectorAll(BAR_SELECTOR).forEach(updateBar);
  };

  const attach = (root) => {
    let raf = 0;
    const run = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => enforce(root));
    };

    run();

    new MutationObserver(run).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  };

  const waitForRoots = () => {
    const roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) {
      requestAnimationFrame(waitForRoots);
      return;
    }
    roots.forEach(attach);
  };

  waitForRoots();
})();

(() => {
  const hasBundleV1 = () => !!document.querySelector('.product__info-container.product-bundle-v1');

  const normText = (t) => (t || '').replace(/\s+/g, ' ').trim();

  const parseMoney = (text) => {
    const t = normText(text);
    if (!t) return null;

    const currencyMatch = t.match(/[$€£¥]|[A-Z]{3}/);
    const currencyToken = currencyMatch ? currencyMatch[0] : '';

    const numMatch = t.match(/-?[\d.,]+/);
    if (!numMatch) return null;

    let numStr = numMatch[0];
    const lastDot = numStr.lastIndexOf('.');
    const lastComma = numStr.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    if (decPos >= 0) {
      const intPart = numStr.slice(0, decPos).replace(/[^\d-]/g, '');
      const decPart = numStr.slice(decPos + 1).replace(/[^\d]/g, '');
      numStr = `${intPart}.${decPart}`;
    } else {
      numStr = numStr.replace(/[^\d-]/g, '');
    }

    const value = Number(numStr);
    if (!Number.isFinite(value)) return null;

    return { value, currencyToken };
  };

  const getSelectedBar = () =>
    document.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected') ||
    document.querySelector('.kaching-bundles__bar');

  const syncFromSelectedBar = () => {
    if (!hasBundleV1()) return;

    const productPrice = document.querySelector('.product__price');
    if (!productPrice) return;

    const bar = getSelectedBar();
    if (!bar) return;

    const barPriceEl = bar.querySelector('.kaching-bundles__bar-price');
    const barCompareEl = bar.querySelector('.kaching-bundles__bar-full-price');
    if (!barPriceEl || !barCompareEl) return;

    const saleText = normText(barPriceEl.textContent);
    const regularText = normText(barCompareEl.textContent);

    const sig = `${saleText}||${regularText}`;
    if (productPrice.dataset.kachingSig === sig) return;
    productPrice.dataset.kachingSig = sig;

    const saleEl = productPrice.querySelector('.price-item--sale');
    const regularEl = productPrice.querySelector('.price-item--regular');

    if (saleEl && saleEl.textContent !== saleText) saleEl.textContent = saleText;

    if (regularEl) {
      if (regularEl.textContent !== regularText) regularEl.textContent = regularText;
      if (regularEl.getAttribute('style')) regularEl.removeAttribute('style');
    }

    const price = parseMoney(saleText);
    const compare = parseMoney(regularText);

    let badge = Array.from(productPrice.children).find(
      (el) => el && el.nodeType === 1 && el.matches('[data-bundle-off="1"]')
    );

    if (price && compare && compare.value > price.value) {
      const offPct = Math.round((1 - price.value / compare.value) * 100);
      const badgeSig = String(offPct);

      if (!badge) {
        badge = document.createElement('span');
        badge.setAttribute('data-bundle-off', '1');
        badge.className = 'bundle-off-badge';
        badge.innerHTML = `<span data-sig="${badgeSig}">${offPct}%</span> OFF`;
        productPrice.appendChild(badge);
      } else {
        if (badge.parentElement !== productPrice || badge !== productPrice.lastElementChild) {
          productPrice.appendChild(badge);
        }
        const valueEl = badge.querySelector('span');
        if (!valueEl || valueEl.dataset.sig !== badgeSig) {
          badge.innerHTML = `<span data-sig="${badgeSig}">${offPct}%</span> OFF`;
        }
      }
    } else {
      if (badge) badge.remove();
    }
  };

  const makeRafRunner = (fn) => {
    let raf = 0;
    return () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        fn();
      });
    };
  };

  const run = makeRafRunner(syncFromSelectedBar);

  const observeBars = () => {
    const anyBar = document.querySelector('.kaching-bundles__bar');
    if (!anyBar) return false;

    const container =
      anyBar.closest('.kaching-bundles') ||
      anyBar.parentElement ||
      document.body;

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes') {
          if (m.target && m.target.classList && m.target.classList.contains('kaching-bundles__bar')) {
            run();
            return;
          }
        }
        if (m.type === 'characterData') {
          run();
          return;
        }
        if (m.type === 'childList') {
          run();
          return;
        }
      }
    });

    mo.observe(container, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    run();
    return true;
  };

  const wait = () => {
    if (!observeBars()) requestAnimationFrame(wait);
  };

  wait();
})();

/* Add domain to terms pages */
document.addEventListener('DOMContentLoaded', function () {
  const shopDomain = window.location.origin;

  const containers = [
    document.querySelector('.main-page-content'),
    document.querySelector('.shopify-policy__container')
  ].filter(Boolean);

  if (!containers.length) return;

  const replaceContent = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('{domain}') || node.nodeValue.includes('derilashop.co.uk')) {
        node.nodeValue = node.nodeValue
          .replaceAll('{domain}', shopDomain)
          .replaceAll('https://derilashop.co.uk', shopDomain);
      }
    }

    root.querySelectorAll('*').forEach(el => {
      [...el.attributes].forEach(attr => {
        if (attr.value.includes('{domain}') || attr.value.includes('derilashop.co.uk')) {
          el.setAttribute(
            attr.name,
            attr.value
              .replaceAll('{domain}', shopDomain)
              .replaceAll('https://derilashop.co.uk', shopDomain)
          );
        }
      });
    });
  };

  containers.forEach(container => replaceContent(container));

  containers.forEach(container => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            replaceContent(node);
          }
        });
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  });
});

/* Bundle builder */
function bundleBuilderInit() {
    document.querySelectorAll('[data-bundle-builder]').forEach(function (root) {
        if (root.dataset.bundleBound) return;
        root.dataset.bundleBound = 'true';

        var tiers = JSON.parse(root.dataset.tiers).sort(function (a, b) { return a.min - b.min; });
        var ctaText = root.dataset.ctaText || 'Add to Cart';
        var maxMessage = root.dataset.maxMessage || '🔥 Maximum savings unlocked — 72% OFF';
        var items = Array.from(root.querySelectorAll('[data-bundle-item]'));

        var tierEls = Array.from(root.querySelectorAll('[data-tier]'));
        var segmentEls = Array.from(root.querySelectorAll('[data-segment]'));
        var bannerEl = root.querySelector('[data-bundle-banner]');
        var messageEl = root.querySelector('[data-bundle-message]');
        var countEl = root.querySelector('[data-selected-count]');
        var priceEl = root.querySelector('[data-total-price]');
        var compareEl = root.querySelector('[data-total-compare]');
        var submitBtn = root.querySelector('[data-bundle-submit]');
        var submitTextEl = root.querySelector('[data-submit-text]');

        function getTier(count) {
            var current = tiers[0];
            tiers.forEach(function (tier) {
                if (count >= tier.min) current = tier;
            });
            return current;
        }

        function getNextTier(count) {
            for (var i = 0; i < tiers.length; i++) {
                if (tiers[i].min > count) return tiers[i];
            }
            return null;
        }

        function update() {
            var count = 0;
            var subtotal = 0;
            var discounted = 0;

            items.forEach(function (item) {
                var qty = parseInt(item.dataset.qty, 10) || 0;
                var price = parseInt(item.dataset.price, 10) || 0;
                count += qty;
                subtotal += price * qty;
            });

            var tier = getTier(count);
            var next = getNextTier(count);
            var percent = (count > 0 && tier) ? tier.percent : 0;

            items.forEach(function (item) {
                var qty = parseInt(item.dataset.qty, 10) || 0;
                if (qty <= 0) return;
                var unitPrice = parseInt(item.dataset.price, 10) || 0;
                var unitDiscounted = percent > 0 ? Math.round(unitPrice * (1 - percent / 100)) : unitPrice;
                discounted += unitDiscounted * qty;
            });

            if (countEl) countEl.textContent = count;
            if (priceEl) priceEl.textContent = getMoney(discounted / 100);
            if (compareEl) {
                if (percent > 0) {
                    compareEl.textContent = getMoney(subtotal / 100);
                    compareEl.hidden = false;
                } else {
                    compareEl.hidden = true;
                }
            }
            if (submitTextEl) {
                submitTextEl.textContent = percent > 0 ? (ctaText + ' - Save ' + percent + '%') : ctaText;
            }
            if (submitBtn) submitBtn.disabled = count === 0;

            if (bannerEl && messageEl) {
                if (next) {
                    var remaining = next.min - count;
                    var word = remaining === 1 ? 'item' : 'items';
                    messageEl.textContent = 'Add ' + remaining + ' more ' + word + ' to unlock ' + next.percent + '% off';
                    bannerEl.hidden = false;
                    bannerEl.classList.remove('is-max');
                } else if (count > 0) {
                    messageEl.textContent = maxMessage;
                    bannerEl.hidden = false;
                    bannerEl.classList.add('is-max');
                } else {
                    bannerEl.hidden = true;
                    bannerEl.classList.remove('is-max');
                }
            }

            tierEls.forEach(function (el) {
                var min = parseInt(el.dataset.tierMin, 10);
                el.classList.toggle('is-active', tier && tier.min === min);
                el.classList.toggle('is-reached', count >= min);
            });

            segmentEls.forEach(function (el) {
                var min = parseInt(el.dataset.tierMin, 10);
                el.classList.toggle('is-reached', count >= min);
            });
        }

        function setQty(item, qty) {
            var min = parseInt(item.dataset.min, 10) || 0;
            qty = Math.max(min, qty);
            item.dataset.qty = qty;

            var valueEl = item.querySelector('[data-qty-value]');
            if (valueEl) valueEl.textContent = qty;

            item.classList.toggle('is-selected', qty > 0);

            var control = item.querySelector('[data-control]');
            if (control) control.classList.toggle('is-stepper', qty > 0);

            update();
        }

        items.forEach(function (item) {
            var addBtn = item.querySelector('[data-add-btn]');
            var minusBtn = item.querySelector('[data-qty-minus]');
            var plusBtn = item.querySelector('[data-qty-plus]');

            if (addBtn) {
                addBtn.addEventListener('click', function () {
                    setQty(item, 1);
                });
            }
            if (minusBtn) {
                minusBtn.addEventListener('click', function () {
                    setQty(item, (parseInt(item.dataset.qty, 10) || 0) - 1);
                });
            }
            if (plusBtn) {
                plusBtn.addEventListener('click', function () {
                    setQty(item, (parseInt(item.dataset.qty, 10) || 0) + 1);
                });
            }
        });

        if (submitBtn) {
            submitBtn.addEventListener('click', function () {
                var lineItems = items
                    .filter(function (item) { return (parseInt(item.dataset.qty, 10) || 0) > 0; })
                    .map(function (item) {
                        return { id: item.dataset.variantId, quantity: parseInt(item.dataset.qty, 10) };
                    });

                if (!lineItems.length) return;

                submitBtn.disabled = true;
                submitBtn.classList.add('is-loading');

                var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: lineItems,
                        sections: cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [],
                        sections_url: window.location.pathname
                    })
                })
                    .then(function (res) { return res.json(); })
                    .then(function (result) {
                        if (result.status) {
                            console.error(result);
                            return;
                        }
                        if (cart) {
                            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                            setTimeout(function () { cart.renderContents(result); }, 100);
                        }
                    })
                    .catch(function (err) { console.error(err); })
                    .finally(function () {
                        submitBtn.disabled = false;
                        submitBtn.classList.remove('is-loading');
                        update();
                    });
            });
        }

        update();
    });
}

function removeGrouptifyBadge() {
    function removeBadge(root) {
        var badge = root.querySelector('div[title="Powered by Grouptify"]');
        if (badge) badge.remove();
    }

    var container = document.querySelector('.product__info-container');
    if (!container) return;

    removeBadge(container);

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.matches && node.matches('div[title="Powered by Grouptify"]')) {
                    node.remove();
                } else if (node.querySelector) {
                    removeBadge(node);
                }
            });
        });
    });

    observer.observe(container, { childList: true });
}